<template>
  <ElDialog
      v-model="isShow"
      :footer="null"
      centered
      :width="500"
      destroyOnClose
      @cancel="close"
  >
    <template #title>
      <!--      {{ userDataInformation }}-->
      <!--      {{ Math.floor((userDataInformation?.mailStorageVo?.freeLocation || 0) / 1024) }}-->
      <!--      {{-->
      <!--        Math.floor(-->
      <!--            ((companyInformation?.freeLocation || 0) - -->
      <!--                (userDataInformation?.mailStorageVo?.effectiveLocation || 0)) / 1024-->
      <!--        )-->
      <!--      }}-->
      <!--      {{ currentItem }}-->
      <span style="margin-left: 65px;font-size: 16px;">{{ $t('system.area') }}</span>
    </template>
    <div style="margin-left: 65px;" class="title_second">
      {{ $t('userinfo.center.child', {account: currentItem?.account}) }}
    </div>
    <div
        style="margin-left: 65px;display: flex;justify-content: center;align-items: flex-start;flex-direction: column;">
      <div style="margin-top: 15px">
        <span style="margin-right: 10px">{{ $t('common.fp') }}</span>
        <el-input-number
            size="small"
            v-model="numSpace"
            @change="(value)=>handleChange(value,1)"
        />
        <span style="color: #0a84ff;font-weight: 600;margin: 0px 6px;">MB</span>
        <span>{{ $t('userinfo.vip.space') }}</span>
        <div class="des_bottom" v-html="targetText"></div>
      </div>
      <div style="margin-top: 15px">
        <span style="margin-right: 10px">{{ $t('common.fp') }}</span>
        <el-input-number size="small" v-model="numEdm" @change="(value)=>handleChange(value,2)"/>
        <span style="color: #0a84ff;font-weight: 600;margin: 0px 10px;">{{ $t('common_ph23') }}</span>
        <span>{{ $t('userinfo.vip.edm') }}</span>
        <div class="des_bottom" v-html="targetText2">
        </div>
      </div>
      <div style="margin-top: 15px">
        <span style="margin-right: 10px">{{ $t('common.fp') }}</span>
        <el-input-number size="small" v-model="numAI" @change="(value)=>handleChange(value,3)"/>
        <span style="color: #0a84ff;font-weight: 600;margin: 0px 10px;">{{ $t('common_ph24') }}</span>
        <span>{{ $t('userinfo.vip.AI') }}</span>
        <div class="des_bottom" v-html="targetText3"></div>
      </div>
    </div>
    <div class="tip" style="margin-left: 65px;">
      {{ $t('userinfo.center.tips') }}
    </div>
    <div class="dialog-footer">
      <ElButton size="small" @click="close">
        {{
          $t("common.cancel")
        }}
      </ElButton>
      <ElButton size="small" type="primary" @click="handleClick" :loading="loading">{{ $t('common.confirm') }}
      </ElButton>
    </div>

  </ElDialog>
</template>

<script setup>
import {ElButton, ElDialog, ElInput, ElMessage} from "element-plus";
import {ref, defineProps, watch, defineEmits, onMounted, computed} from 'vue'
import {useStore} from "vuex";
import DialogTwo from "@/components/DiaPops/ChildUserDelete/DialogTwo.vue";
import {distributionLocation} from "@/api/usercenter";
import {formatSize, spaceSizeFormat} from "../../utils/file";
import {isEmpty} from "@/utils/mylodash";
import {i18n} from "@/lang";
import {useI18n} from 'vue-i18n'

const {t} = useI18n()

const store = useStore();
const emit = defineEmits()
const isShow = ref(false);
const loading = ref(false)
const numSpace = ref(0)
const numEdm = ref(0)
const numAI = ref(0)
const companyInformation = computed(() => store.state.user.companyInformation)
const userDataInformation = computed(() => store.state.cloud.userDataInformation)
const {value, isHeadLine, currentItem} = defineProps({
  value: {type: Boolean, default: false},
  isHeadLine: {type: Boolean, default: false},
  currentItem: {type: Object, default: {}}
})

watch(() => value, (val) => {
  isShow.value = val;
}, {immediate: true})
const close = () => {
  emit("close");
}

const update = () => {
  emit("update");
}

const targetText = computed(() => t('userinfo.center.sent', {
  use: spaceSizeFormat(companyInformation.value?.freeLocation ?? 0 - userDataInformation.value?.mailStorageVo?.effectiveLocation ?? 0),
  recycle: spaceSizeFormat(currentItem?.effectiveLocation ?? 0),
  total: spaceSizeFormat(userDataInformation.value?.mailStorageVo?.freeLocation ?? 0)
}))

const unit = ref(i18n.global.t('common_ph23'))
const targetText2 = computed(() => t('userinfo.center.sent', {
  use: `${companyInformation.value?.edmTotalNum ?? 0 - userDataInformation.value?.freeEdmNum ?? 0}${unit.value}`,
  recycle: `${currentItem?.freeEdmNum ?? 0}${unit.value}`,
  total: `${userDataInformation.value?.freeEdmNum ?? 0}${unit.value}`
}))

const unitSp = ref(i18n.global.t('common_ph24'))
const targetText3 = computed(() => t('userinfo.center.sent', {
  use: `${companyInformation.value?.totalAiNum ?? 0 - userDataInformation.value?.freeAiNum ?? 0}${unitSp.value}`,
  recycle: `${currentItem?.freeAiNum ?? 0}${unitSp.value}`,
  total: `${userDataInformation.value?.freeAiNum ?? 0}${unitSp.value}`
}))


const visibleDialogTwo = ref(false)
const handleDelete = () => {
  visibleDialogTwo.value = true
}

const deleteTarget = () => {
  emit("deleteTarget")
}

const maxLimit = computed(() =>
    Math.floor((userDataInformation.value?.mailStorageVo?.freeLocation || 0) / 1024)
)
const minLimit = computed(() => {
  const diff = currentItem?.effectiveLocation
  return Math.floor(-diff / 1024) // 保证是负数
})

const maxLimitEDM = computed(() => (userDataInformation.value?.freeEdmNum || 0))
const minLimitEDM = computed(() => {
  const diff = currentItem?.freeEdmNum
  console.log(diff, 'diff')
  return -diff
})

const maxLimitAI = computed(() => (userDataInformation.value?.freeAiNum || 0))
const minLimitAI = computed(() => {
  const diff = currentItem?.freeAiNum
  return -diff
})

const handleChange = (val, type) => {
  console.log(val, type, 'val')
  if (type === 1) {
    numSpace.value = limitSpaceInput(val, minLimit.value, maxLimit.value)
  } else if (type === 2) {
    numEdm.value = limitSpaceInput(val, minLimitEDM.value, maxLimitEDM.value)
  } else if (type === 3) {
    numAI.value = limitSpaceInput(val, minLimitAI.value, maxLimitAI.value)
  }
}

/**
 * 限制空间输入值在指定范围内
 * @param {number} val 用户输入值（KB）
 * @param {number} min 最小值（KB）
 * @param {number} max 最大值（KB）
 * @returns {number} 限制后的值
 */
const limitSpaceInput = (val, min, max) => {
  if (min > max) {
    console.warn(`[limitSpaceInput] min (${min}) > max (${max})，请检查逻辑`);
  }
  if (val > max) return max
  if (val < min) return min
  return val
}

// 分配空间
const handleClick = async () => {
  try {
    loading.value = true
    const payload = {
      id: currentItem?.id,
      locationNum: numSpace.value * 1024,
      edmNum: numEdm.value,
      aiNum: numAI.value,
    }
    await distributionLocation(payload).then(res => {
      if (res.code === 200) {
        ElMessage.success(res.result)
        update()
        close()
      }
    })
  } catch (e) {
    loading.value = false
  }
}

onMounted(async () => {
  await store.dispatch("user/getCompanyCurrentInfoApis")
  if (isEmpty(userDataInformation)) {
    await store.dispatch("cloud/queryByUserIdApis")
  }
})
</script>
<style scoped lang="less">
.fx-j-c {
  display: flex;
  justify-content: center;
  margin-top: 40px;
}

.title_cdir {
  color: rgba(0, 0, 0, .85);
  font-weight: 700;
  font-size: 14px;
}

.fx-j-r {
  display: flex;
  justify-content: right;
  margin-top: 40px;
}

.dialog-footer {
  margin-top: 30px;
  width: 100%;
  display: flex;
  justify-content: flex-end;
}

.font {
  font-weight: 400;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.85);
}

.font_middle {
  font-weight: 600;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.85);
  line-height: 32px;
}

.title_second {
  color: rgba(0, 0, 0, .85);
  font-size: 14px;
  font-weight: 500;
}

.tip {
  margin-top: 20px;
  font-size: 12px;
}

.des_bottom {
  margin-top: 5px;
}
</style>
